
export const EnKeyMaps = new Map([
  ['title', 'FAQs'],
]);

export const ZhKeyMaps = new Map([
  ['title', '常见问题'],
]);
